import { render } from "./Images.vue?vue&type=template&id=e907ed26&scoped=true"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"

import "./Images.vue?vue&type=style&index=0&id=e907ed26&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e907ed26"]])

export default __exports__